import { dashboardSlice } from "./dashboardSlice";

const { actions } = dashboardSlice;

export const loading = loader => dispatch => {
  return dispatch(actions.dashboardListLoading(loader));
};

export const list = payload => dispatch => {
  try {
    dispatch(actions.startCall());
    return dispatch(actions.categoryList(payload));
  } catch (err) {
    dispatch(actions.catchError(err));
  }
};

export const featuredAssetList = payload => dispatch => {
  try {
    dispatch(actions.startCall());
    return dispatch(actions.featuredAssetList(payload));
  } catch (err) {
    dispatch(actions.catchError(err));
  }
};

export const notificationList = payload => dispatch => {
  try {
    dispatch(actions.startCall());
    return dispatch(actions.notificationList(payload));
  } catch (err) {
    dispatch(actions.catchError(err));
  }
};
